// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export var ProcessorType;
(function (ProcessorType) {
    ProcessorType[ProcessorType["I2C"] = 3] = "I2C";
    ProcessorType[ProcessorType["Alegeus"] = 9] = "Alegeus";
    ProcessorType[ProcessorType["TChek"] = 10] = "TChek";
})(ProcessorType || (ProcessorType = {}));
//# sourceMappingURL=processorType.js.map